// หน้าโหลดแบบโลโก้ (พื้นมืด + โลโก้เว็บกลางจอ + ตัวหมุน) — ใช้ได้ทุกหน้า
// เรียกใช้: showLoading() / hideLoading()  หรือ withLoading(promise)
// - นับจำนวนงานที่ค้างอยู่ (หลายคำขอพร้อมกันก็ปิดเมื่อเสร็จครบ)
// - ขึ้นหลังรอ 120ms (งานเร็วมากจะไม่กะพริบ) และปิดเองถ้าค้างเกิน 30 วินาที
import './loader.css';

const LOGO_KEY = 'bt_logo';
const FALLBACK_LOGO = '/build/web/igame-index-lobby-wm/img/logo.png';
let el = null;
let count = 0;
let showTimer = null;
let safetyTimer = null;

export function setLoaderLogo(url) {
  if (!url) return;
  try { localStorage.setItem(LOGO_KEY, url); } catch (e) { /* ignore */ }
  const img = el && el.querySelector('.bt-loader-logo');
  if (img && img.getAttribute('src') !== url) img.setAttribute('src', url);
}

function logoUrl() {
  try { return localStorage.getItem(LOGO_KEY) || FALLBACK_LOGO; } catch (e) { return FALLBACK_LOGO; }
}

function ensureEl() {
  if (el || typeof document === 'undefined') return el;
  el = document.createElement('div');
  el.className = 'bt-loader';
  el.setAttribute('data-no-i18n', '');
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML =
    '<div class="bt-loader-inner">' +
    '<img class="bt-loader-logo" alt="" />' +
    '<div class="bt-loader-spin"><span></span><span></span><span></span></div>' +
    '</div>';
  el.querySelector('.bt-loader-logo').setAttribute('src', logoUrl());
  el.querySelector('.bt-loader-logo').onerror = function onErr() { this.style.visibility = 'hidden'; };
  document.body.appendChild(el);
  return el;
}

function reallyShow() {
  const node = ensureEl();
  if (!node) return;
  const img = node.querySelector('.bt-loader-logo');
  const url = logoUrl();
  if (img.getAttribute('src') !== url) { img.style.visibility = ''; img.setAttribute('src', url); }
  node.classList.add('show');
}

export function showLoading() {
  count += 1;
  if (count === 1) {
    clearTimeout(showTimer);
    showTimer = setTimeout(reallyShow, 120);
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(() => { count = 0; hideNow(); }, 30000);
  }
}

function hideNow() {
  clearTimeout(showTimer);
  clearTimeout(safetyTimer);
  if (el) el.classList.remove('show');
}

export function hideLoading() {
  count = Math.max(0, count - 1);
  if (count === 0) hideNow();
}

// แสดงโหลดสั้น ๆ (เช่นตอนกดปุ่ม เข้าสู่ระบบ / สมัครสมาชิก แล้วเปลี่ยนหน้า)
export function flashLoading(ms = 700) {
  showLoading();
  setTimeout(hideLoading, ms);
}

export async function withLoading(p) {
  showLoading();
  try { return await p; } finally { hideLoading(); }
}

if (typeof window !== 'undefined') {
  window.btLoading = { show: showLoading, hide: hideLoading, flash: flashLoading, setLogo: setLoaderLogo };
}
